(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.atelier-group-entrance';
    const initializedAttribute = 'data-atelier-entrance-initialized';
    const reducedMotionQuery = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    let observer;

    const prepareChildStagger = (group) => {
      if (
        !group.classList.contains(
          'atelier-group-entrance--stagger'
        )
      ) {
        return;
      }

      const content = group.querySelector(
        ':scope > .group-block-content'
      );

      if (!content) return;

      const styles = window.getComputedStyle(group);

      const stagger =
        parseFloat(
          styles.getPropertyValue('--atelier-child-stagger')
        ) || 90;

      Array.from(content.children).forEach((child, index) => {
        const staggerPosition = Math.min(index, 8);
        const delay = 120 + staggerPosition * stagger;

        child.style.setProperty(
          '--atelier-child-delay',
          `${delay}ms`
        );
      });
    };

    const revealGroup = (group, immediate = false) => {
      if (group.classList.contains('is-visible')) return;

      const show = () => {
        group.classList.add('is-visible');

        const styles = window.getComputedStyle(group);

        const duration =
          parseFloat(
            styles.getPropertyValue(
              '--atelier-entrance-duration'
            )
          ) || 850;

        window.setTimeout(() => {
          group.classList.add('is-animation-complete');
        }, duration + 300);
      };

      /*
       * The Theme Editor can reveal selected blocks immediately.
       * The storefront waits briefly so the hidden state is painted
       * before the transition begins.
       */
      if (immediate || reducedMotionQuery.matches) {
        show();
      } else {
        window.setTimeout(() => {
          window.requestAnimationFrame(show);
        }, 80);
      }

      observer?.unobserve(group);
    };

    const createObserver = () => {
      if (observer) return;

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            revealGroup(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -7% 0px'
        }
      );
    };

    const initializeGroups = (scope = document) => {
      let groups = [];

      if (
        scope instanceof Element &&
        scope.matches(selector)
      ) {
        groups = [scope];
      } else {
        groups = Array.from(
          scope.querySelectorAll(selector)
        );
      }

      groups.forEach((group) => {
        if (
          group.hasAttribute(initializedAttribute)
        ) {
          return;
        }

        group.setAttribute(
          initializedAttribute,
          'true'
        );

        prepareChildStagger(group);

        if (reducedMotionQuery.matches) {
          revealGroup(group, true);
          return;
        }

        observer.observe(group);
      });
    };

    const initialize = () => {
      createObserver();

      /*
       * First enable the hidden animation state.
       */
      document.documentElement.classList.add(
        'atelier-entrance-ready'
      );

      /*
       * Wait for two browser frames.
       * Frame 1 applies the hidden state.
       * Frame 2 starts observing and revealing.
       */
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          initializeGroups(document);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initialize,
        { once: true }
      );
    } else {
      initialize();
    }

    /*
     * Handle sections dynamically loaded by Shopify.
     */
    document.addEventListener(
      'shopify:section:load',
      (event) => {
        createObserver();

        window.requestAnimationFrame(() => {
          initializeGroups(event.target);
        });
      }
    );

    /*
     * Theme Editor only:
     * reveal a selected group immediately.
     */
    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const selectedGroup =
          event.target.matches?.(selector)
            ? event.target
            : event.target.closest?.(selector);

        if (!selectedGroup) return;

        prepareChildStagger(selectedGroup);
        revealGroup(selectedGroup, true);
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
